import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            热门人物视频内容精选，深度解读与精彩回顾一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-medium text-foreground-900 text-sm mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}